import axios from "axios";
import Config from "../../../config";

const v2_actionDeletarLeadsMassa = (clienteId, ids) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/deletar-massa`,
        data: { cliente_id: clienteId, ids },
    });
};

export default v2_actionDeletarLeadsMassa;
